export default __webpack_public_path__ + "static/favicon-sendtodeliver-4a992e39295e8b8088f41fadd6ad56c2.png";